"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Top link
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.toTopLink = {
    initialize: function () {
        'use strict';
        var $header = $('#header');
        var $body = $('body');
        var triggerHeight = $header.height();
        var $toTopLink = $('#link_to_top');
        $toTopLink.on('click.txGs1Base', function (event) {
            event.preventDefault();
            $('body, html').animate({
                'scrollTop': 0
            }, 150);
        });
        $(window).on('scroll.txGs1Base', $.throttle(250, function (event) {
            var scrollTop = $(document).scrollTop();
            if (scrollTop > triggerHeight) {
                $body.addClass('to-top-link-visible');
            }
            else {
                $body.removeClass('to-top-link-visible');
            }
        }));
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['handheld', 'tablet_portrait', 'tablet_landscape'],
            enter: function () {
                $toTopLink.data('class', $toTopLink.attr('class'));
                $toTopLink.attr('class', 'btn-flat arrow-up');
            },
            exit: function () {
                $toTopLink.attr('class', $toTopLink.data('class'));
            }
        });
    }
};
exports.default = {};
